import axios from "axios";
import router from "@/router";
import { ElMessage, ElLoading } from "element-plus";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
  responseType: "json",
  headers: {
    "Content-Type": "application/json;charset=utf-8", // 默认请求头
  },
});

// 全局loading实例
let loadingInstance = null;
// 记录当前请求数量
let requestCount = 0;

// 显示loading
// const showLoading = () => {
//   if (requestCount === 0) {
//     loadingInstance = ElLoading.service({
//       lock: true,
//       text: '加载中...',
//       background: 'rgba(0, 0, 0, 0.5)'
//     })
//   }
//   requestCount++
// }

// 隐藏loading
const hideLoading = () => {
  if (requestCount <= 0) return;
  requestCount--;
  if (requestCount === 0) {
    loadingInstance?.close();
  }
};

// 请求拦截器
service.interceptors.request.use(
  (config) => {
  
    if (!config.url?.includes("/api/auth/login")) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
    }

    if (config.method === "get" && config.params) {
      Object.keys(config.params).forEach((key) => {
        if (
          config.params[key] === null ||
          config.params[key] === undefined ||
          config.params[key] === ""
        ) {
          delete config.params[key];
        }
      });
    }

    return config;
  },
  (error) => {
    hideLoading();
    console.error("请求错误:", error);
    ElMessage.error("请求发送失败");
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // hideLoading();
    const res = response.data;
    return res;
  },
  (error) => {
   
    const code = error.response.data.code;
    if (code === 401) {
      localStorage.removeItem("token");
      // 跳转到登录页面
      router.push("/login");
      ElMessage.error("登录已过期，请重新登录");
    }

    // hideLoading();

    try {
      // 处理网络错误
      if (!error.response) {
        // 处理超时错误
        if (
          error.code === "ECONNABORTED" ||
          error.message.includes("timeout")
        ) {
          ElMessage.error("网络请求超时，请稍后重试");
        } else {
          ElMessage.error("网络连接失败，请检查网络设置");
        }
      } else {
        // 处理状态码错误
        const status = error.response.status;
        console.log("状态码:", status);

        switch (status) {
          case 400:
            ElMessage.error(error.response.data?.message || "请求参数错误");
            break;
          case 401:
            // 清除token
            localStorage.removeItem("token");
            // 跳转到登录页面
            router.push("/login");
            ElMessage.error("登录已过期，请重新登录");
            break;
          case 403:
            ElMessage.error("没有权限访问该资源");
            break;
          case 404:
            ElMessage.error("请求的资源不存在");
            break;
          case 500:
            ElMessage.error("请联系管理员");
            break;
          case 502:
            ElMessage.error("网关错误");
            break;
          case 503:
            ElMessage.error("服务器暂时不可用");
            break;
          case 504:
            ElMessage.error("网关超时");
            break;
          default:
            ElMessage.error(error.response.data?.message || "请求失败");
        }
      }
    } catch (err) {
      console.error("错误处理失败:", err);
      ElMessage.error("请联系管理员");
    }

    return Promise.resolve({ code: 500, message: "请求失败，请联系管理员" });
  },
);

export default service;
